import { createContext } from 'react';

type registerCardType = (card: any) => any[];

type CardsContextType = {
  registerCard: registerCardType;
};

export const CardsContext = createContext<CardsContextType>({
  registerCard: () => []
});
